import EscalationWebhookSection from "@/components/agent/details/EscalationWebhookSection";
import { OverviewSectionCard } from "@/components/agent/overview/OverviewSectionCard";
import { Agent } from "@/types/agent/agent";

interface EscalationWebhookCardProps {
  agent: Agent;
  brand?: string;
}

export const EscalationWebhookCard = ({ agent, brand = "#4E9CFF" }: EscalationWebhookCardProps) => {
  return (
    <OverviewSectionCard
      title="Escalation Webhook"
      subtitle="Trigger webhooks when the genie escalates a conversation"
      genieIcon="webhook"
      brand={brand}
      secondaryColor={agent.branding?.secondaryColor}
      gradientEnabled={agent.branding?.gradientEnabled}
      gradientAngle={agent.branding?.gradientAngle}
    >
      <EscalationWebhookSection agentId={agent.id} brand={brand} />
    </OverviewSectionCard>
  );
};
